import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FolderClosed, Home, User } from 'lucide-react';
import { useRouter } from 'next/router';

import { useStorage } from 'hooks/useStorage';

import { isValidOrigin } from 'utils/validate-origin';

import { Crumb } from 'components/Breadcrumb';
import { Bar } from 'components/Tabbar';

import { MainWrapper } from '../wrappers/MainWrapper';

export const patientAreaOriginKey = 'PATIENT_AREA_ORIGIN';

export function PatientAreaWrapper({ children }: React.PropsWithChildren) {
  const { t } = useTranslation();
  const router = useRouter();

  const crumbs: Array<Crumb> = [
    {
      content: 'Home',
      href: '/patient-area',
      icon: Home,
    },
  ];

  const tabs: Array<Bar> = [
    {
      content: t('page--patient-area.tabDocumentsTitle'),
      href: `/patient-area`,
      icon: FolderClosed,
    },
    {
      content: t('page--patient-area.tabYourDataTitle'),
      href: `/patient-area/profile`,
      icon: User,
    },
  ];

  const { get, set } = useStorage();

  useEffect(() => {
    if (!router.isReady && !router.query?.origin) return;

    set(patientAreaOriginKey, router.query.origin);
  }, [router, set]);

  const tryParse = (value: string) => {
    try {
      return JSON.parse(value);
    } catch (error) {
      return undefined;
    }
  };

  const originUrl = tryParse(get(patientAreaOriginKey));

  return (
    <MainWrapper
      title={t('page--patient-area.title')}
      backButtonRoute={
        typeof window !== 'undefined' &&
        originUrl &&
        originUrl !== 'undefined' &&
        isValidOrigin(originUrl)
          ? originUrl || '/'
          : '/'
      }
      crumbs={crumbs}
      haveTabbar
      tabs={tabs}
    >
      {children}
    </MainWrapper>
  );
}
